import { render } from "./ModalPresenza.vue?vue&type=template&id=6d1cb222&scoped=true"
import script from "./ModalPresenza.vue?vue&type=script&lang=js"
export * from "./ModalPresenza.vue?vue&type=script&lang=js"

import "./ModalPresenza.vue?vue&type=style&index=0&id=6d1cb222&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6d1cb222"

export default script